import { IDENTITIES_KEYS, IDENTITIES_VALUES_TYPES, IDENTITY_STATE, VALUES_TYPES, } from '../types';
import { castBoolean } from './utils';
/**
 * Extract just values for each identity
 */
export const getJustIdentitiesValues = (identities) => {
    return Object.keys(identities).reduce((acc, k) => {
        acc[k] = identities[k].value;
        return acc;
    }, {});
};
/**
 * Is identificator valid? (Is it out of scope of this lib?).
 */
export const validateIdentificator = (identificator) => {
    if (typeof identificator !== 'string') {
        return false;
    }
    const identificatorSplit = identificator.split('.');
    return identificatorSplit[0] in IDENTITIES_KEYS;
};
/**
 * Is value type valid? If it is "translatable" ("1234" to 1234) -> do it
 */
export const validateValueType = (identificator, value) => {
    const expectedType = IDENTITIES_VALUES_TYPES[identificator];
    const handler = (value, castedValue) => {
        try {
            // eslint-disable-next-line eqeqeq
            if (value == castedValue) {
                return { ok: true, value: castedValue };
            }
            else {
                return { ok: false };
            }
        }
        catch (_a) {
            return { ok: false };
        }
    };
    // clearing -> allow NULL value
    if (value === null) {
        return { ok: true, value };
    }
    // STRING vs INT
    if (expectedType === VALUES_TYPES.integer && typeof value === VALUES_TYPES.string) {
        return handler(value, parseInt(value, 10));
    }
    // INT / STRING vs BOOLEAN
    if (expectedType === VALUES_TYPES.boolean && typeof value !== VALUES_TYPES.boolean) {
        const casted = castBoolean(value);
        return handler(casted !== null && casted !== void 0 ? casted : value, casted);
    }
    // non valid -> ignored
    if ((expectedType === VALUES_TYPES.string && typeof value !== VALUES_TYPES.string) ||
        (expectedType === VALUES_TYPES.array && !Array.isArray(value)) ||
        (expectedType === VALUES_TYPES.object && (typeof value !== VALUES_TYPES.object || Array.isArray(value)))) {
        return { ok: false };
    }
    return { ok: true, value };
};
/**
 * Generate value object (add timestamps, ...)
 */
export const createIdentityObject = (storageItem, value, state = IDENTITY_STATE.fresh, settled = false) => {
    return {
        value,
        created: (storageItem === null || storageItem === void 0 ? void 0 : storageItem.created) || Date.now(),
        updated: (settled && (storageItem === null || storageItem === void 0 ? void 0 : storageItem.state) === IDENTITY_STATE.fresh) || !(storageItem === null || storageItem === void 0 ? void 0 : storageItem.updated)
            ? Date.now()
            : storageItem.updated,
        state,
        settled,
    };
};
/**
 * Identity helpers
 */
// value extractor
export const identityOutput = (identity, rich = false) => (rich ? identity : identity.value);
// state validator
export const isStateValid = (identity, cacheEnough = false) => (identity === null || identity === void 0 ? void 0 : identity.state) === IDENTITY_STATE.fresh || cacheEnough;
// "get" rules validator
export const isOK = (identity, cacheEnough = false, justSettled = true) => identity && (!justSettled || (identity === null || identity === void 0 ? void 0 : identity.settled)) && isStateValid(identity, cacheEnough);
